import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout.js";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { apiFetch } from "../../api.js";

const ExpCategoryMasterDetailsDesign = () => {
  const navigate = useNavigate();
  const [Category, setCategory] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const routerLocation = useLocation();
  const [ipAddress, setIpAddress] = useState("");
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const location = useLocation();
  const [editId, setEditId] = useState("");

  useEffect(() => {
    axios
      .get("/api/get-ip")
      .then((res) => setIpAddress(res.data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);

  //----------------handleExit
  const handleExit = () => {
    navigate("/ExpCategoryMasterGrid");
  };

  //----------------handleSave
  const handleSave = async () => {
    if (!Category.trim()) {
      alert("Category is required");
      return;
    }

    try {
      const res = await apiFetch(
        "/api/exp-category/save",
        {
          method: "POST",
          body: JSON.stringify({
            category: Category,
            ip: ipAddress,
            userId: storedUserInfo.userId,
            serverIp: window.location.hostname,
          }),
        },
      );

      if (!res.ok) {
        const errText = await res.text();
        console.error("SAVE ERROR:", errText);
        alert("Save failed");
        return;
      }

      const data = await res.json();

      if (data.err === "0") {
        alert("Saved successfully");
        setCategory("");
        navigate("/ExpCategoryMasterGrid");
      } else {
        alert(data.msg);
      }
    } catch (error) {
      console.error(error);
      alert("Server error");
    }
  };
  //------loadEditData
  useEffect(() => {
    if (location.state?.unqid) {
      setIsEditing(true);
      setEditId(location.state.unqid);
      loadEditData(location.state.unqid);
    }
  }, []);

  const loadEditData = async (id) => {
    try {
      const res = await apiFetch(
        `/api/exp-category/edit/${id}`,
        {
          method: "GET",
        },
      );

      if (!res.ok) {
        const errText = await res.text();
        console.error("EDIT LOAD ERROR:", errText);
        return;
      }

      const data = await res.json();

      if (data && data.length > 0) {
        setCategory(data[0].category);
      }
    } catch (err) {
      console.error("Edit Load Error", err);
    }
  };
  //------handleUpdate
  const handleUpdate = async () => {
    if (!Category.trim()) {
      alert("Category is required");
      return;
    }

    try {
      const res = await apiFetch(
        "/api/exp-category/update",
        {
          method: "POST",
          body: JSON.stringify({
            unqid: editId,
            category: Category,
            userId: storedUserInfo.userId,
            ip: ipAddress,
            serverId: window.location.hostname,
          }),
        },
      );

      if (!res.ok) {
        const errText = await res.text();
        console.error("UPDATE ERROR:", errText);
        alert("Update failed");
        return;
      }

      const data = await res.json();

      if (data.err === "0") {
        alert("Updated successfully");
        navigate("/ExpCategoryMasterGrid");
      } else {
        alert(data.msg);
      }
    } catch (err) {
      console.error("Update Error", err);
      alert("Server error");
    }
  };

  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">Category Master</div>

          {/* ---------------- FORM ROW (NOW COMPACT & CLEAN) ---------------- */}
          <div className="form-row compact-row">
            {/* DESCRIPTION */}
            <div className="form-column">
              <label>Category</label>
              <input
                type="text"
                value={Category}
                onChange={(e) => setCategory(e.target.value)}
              />
            </div>
          </div>

          {/* ---------------- BUTTONS ---------------- */}
          <div className="button-container">
            {!isEditing && (
              <button className="btn-save" onClick={handleSave}>
                Save
              </button>
            )}

            {isEditing && (
              <button
                style={{ backgroundColor: "#2e20abff", color: "#fff" }}
                type="button"
                onClick={handleUpdate}
              >
                Update
              </button>
            )}

            <button className="btn-exit" onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>

      {/* ----------------------------------------------------
            CSS - YOUR ORIGINAL STYLE + IMPROVEMENTS
      ---------------------------------------------------- */}
      <style>
        {`
/* ===== PAGE LAYOUT ===== */
.page-container {
  width: 100%;
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 1200px;   /* clean desktop width */
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

/* HEADER */
.header {
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  padding: 15px;
  background: #8B1E3F;
  color: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
}

/* ===== FORM GRID ===== */
.compact-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 💻 desktop = 4 columns */
  gap: 16px;
}

/* UNIFORM INPUTS */
.form-column {
  display: flex;
  flex-direction: column;
}

label {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
}

input,
select {
  width: 100%;              /* ✅ responsive fix */
  height: 40px;
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: #fff;
  box-sizing: border-box;
  font-size: 14px;
}

/* ===== BUTTONS ===== */
.button-container {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.btn-save {
  background: #4caf50;
  color: #fff;
  border: none;
  padding: 10px 26px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
}

.btn-exit {
  background: #a20d0d;
  color: #fff;
  border: none;
  padding: 10px 26px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
}

/* ===== TABLET ===== */
@media (max-width: 1024px) {
  .compact-row {
    grid-template-columns: repeat(2, 1fr); /* 📲 2 columns */
  }
}

/* ===== MOBILE ===== */
@media (max-width: 600px) {
  .compact-row {
    grid-template-columns: 1fr; /* 📱 single column */
  }

  .button-container {
    flex-direction: row;
  }
}

`}
      </style>
    </Layout>
  );
};

export default ExpCategoryMasterDetailsDesign;
